// extracted by mini-css-extract-plugin
export var address = "AddressList_address__3CP9j";
export var addressMargin = "AddressList_addressMargin__CqXbL";
export var removeAddress = "AddressList_removeAddress__KgMB2";
export var row = "AddressList_row__UN4-d";
export var rowAccount = "AddressList_rowAccount__GuxhO";
export var rows = "AddressList_rows__FOfAC";